import * as L from 'leaflet';


class Webcams {

  map;
  loadedCams = [];
  featureGroup;

  constructor(map, featureGroup) {
    this.map = map;
    this.featureGroup = featureGroup;
  }

  async loadCams() {
    const zoom = this.map.getZoom();
    if (zoom <= 11) {
      this.loadedCams = [];
      this.featureGroup.clearLayers();
      return;
    }
    const b = this.map.getBounds();
    const data = await fetch(`/sh/webcams/${b.getWest()}/${b.getSouth()}/${b.getEast()}/${b.getNorth()}`);
    const dataJ = await data.json();
    this.mkWebcamMarker(dataJ);
  }

  mkWebcamMarker(data) {
    let myMarker, wcImage;
    // console.log('gjdata: ', data);
    const l = new L.GeoJSON(data, {
      pointToLayer: (data, latlng) => {
        if (this.loadedCams.indexOf(data._id) >= 0) {
          return;
        }
        myMarker = new L.Marker(latlng);
        var pop = new L.Popup({
          offset: [0, -30],
          className: "wcPopup"
        });
        // console.log("WEBCAM: ", data.properties);
        if (data.properties.player) {
          wcImage = `<a target='_wc_window' href='${data.properties.player}'> 
            <img class='webcamIcon' src='${data.properties.thumbnail}&amp;t=38' alt='webcam' ></a>`;
        } else {
          wcImage = `<img class='webcamIcon' src='${data.properties.thumbnail}' alt='webcam' >`;
        }
        pop.setContent(`<div class='wcContainer'>${wcImage}</div>`);
        myMarker.bindPopup(pop);
        return myMarker;
      },
      onEachFeature: (ft, layer) => {
        if (this.loadedCams.indexOf(ft._id) >= 0) {
          return;
        }
        // console.log('adding layer to group: ', layer, ft);
        layer.properties = ft.properties;
        layer._id = ft._id;
        layer.setIcon(L.divIcon({
          iconSize: [34, 32],
          className: 'icon-webcam freerideinfo freerideinfoWarning'
        }));
        this.featureGroup.addLayer(layer);
        this.loadedCams.push(ft._id);
      }
    });
    // console.log('all markers from geojson: ', l);
    return l;
  }
  
}

const WebcamLayer = L.FeatureGroup.extend({
  onAdd: function (map) {
    const webcams = new Webcams(map, this);
    webcams.loadCams();
    map.on("moveend", () => {
      webcams.loadCams();
    })
  },
});

export { WebcamLayer };

